// core, form, route
import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';

// services
import {UserRegistrationServiceService} from '../user-registration/service/user-registration-service.service';
import {UtilsService} from '../utils/utils.service';

// bootstrap
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';

// custom validator
import {PasswordValidation} from '../shared/services/password-validation';

// custom component
import {ConfirmationModal} from '../shared/dialogs/confirmation-modal/confirmation-modal.component';
import {MyProfileChangePassword} from './model/my-profile-change-password.model';

// constants
import {AppConstants} from '../utils/constants';
import {ErrorModal} from "../shared/dialogs/error-modal/error-modal.component";
import {catchError, map, tap} from "rxjs/operators";
import {of} from "rxjs";

@Component({
    selector: 'my-profile-change-password',
    templateUrl: './my-profile-change-password.component.html',
    styleUrls: ['./my-profile-change-password.component.scss'],
    standalone: false
})
export class MyProfileChangePasswordComponent implements OnInit {

  private changePasswordForm: UntypedFormGroup;
  bsModalRef: BsModalRef;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _userRegistrationService: UserRegistrationServiceService,
    private _route: Router,
    private _utils: UtilsService,
    private _modalService: BsModalService
  ) {
    this.changePasswordForm = _formBuilder.group({
      oldPassword: [
        {
          value: '',
          disabled: false
        },
        Validators.compose([
          Validators.required
        ]),
      ],
      password: [
        {
          value: '',
          disabled: false
        },
        Validators.compose([
          Validators.required,
          Validators.pattern(this._utils.getPasswordRegex()),
          Validators.minLength(8)
        ])
      ],
      confirmPassword: [
        {
          value: '',
          disabled: false
        },
        Validators.compose([
          Validators.required
        ])
      ]
    }, {
      validator: PasswordValidation.MatchPassword('password', 'confirmPassword')
    });
  }

  ngOnInit() {
  }

  public getChangePasswordForm() {
    return this.changePasswordForm;
  }

  public save(formValues) {
    const changePasswordObject = this.getMyProfileChangePasswordObject(formValues);
    this._userRegistrationService.myProfileChangePassword(changePasswordObject).pipe(
      tap((response: any) => {
        this._openConfirmationModal(response);
      }),
      catchError((response: any) => {
        this._openErrorModal(response);
        return of(null);
      })
    ).subscribe();
  }

  public getMyProfileChangePasswordObject(formValues) {
    const changePassword: MyProfileChangePassword = new MyProfileChangePassword();
    changePassword.currentPassword = formValues.oldPassword;
    changePassword.newPassword = formValues.password;
    changePassword.repeatNewPassword = formValues.confirmPassword;
    return changePassword;
  }

  private _openConfirmationModal(msg: string) {
    this.bsModalRef = this._modalService.show(ConfirmationModal);
    this.bsModalRef.content.confirmationMessage = msg;
    this._modalService.onHide.subscribe(res => this._route.navigateByUrl(AppConstants.myProfile));
  }

  private _openErrorModal(msg: string) {
    this.bsModalRef = this._modalService.show(ErrorModal);
    this.bsModalRef.content.errorMessage = msg;
  }

}
